/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { url } from 'utils/urls'
// material
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import Space from 'material/space/space';
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import { Tip } from '@insticator/insticator-ui'
// styles
import injectSheet from 'react-jss'
import styles from './loadbehindbutton_styles'
import PreviewConfig from '../../previewconfig/previewconfig';
import { TextAreaField, TextField, Button } from '@insticator/insticator-ui/dist/material';

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : LOAD BEHIND BUTTON ~~~~~~~~~~ ========== */
const LoadBehindButton = injectSheet(styles)((props) => {

  const { useLoadBehindButton, loadBehindButtonTitle, loadBehindButtonDescription, loadBehindButtonText, onChange } = props

  return (
    <SectionGroupV2 klass={`loadbehindbutton ${props.classes.loadbehindbutton}`} title={'Login to View Comments'} description={<span>Comments are hidden by default and users are required to login to view them. <Tip space={'none'} icon={'question-circle'} content={'This can help with toxicity scores but will, most likely, negatively impact user engagement and revenue generation.'} label={''} /></span>} rowGap={32} direction={'column'}>
      <ConfigToggle 
        title={'Enable login to view'}
        description={'Users will have to authenticate to see comments.'}
        checked={useLoadBehindButton}
        onChange={val => onChange('useLoadBehindButton', val)}
      >
        <Space gap={48}>
          <Space direction={'column'}>
            <TextField 
              type={`text`} 
              name={`loadbehindbuttontitle`} 
              icon={<ComposeIcon />}
              label={'Title'}
              value={loadBehindButtonTitle} 
              handleChange={e => onChange('loadBehindButtonTitle', e.target.value)}
              placeholder={`Enter title`} 
              required
              valid={useLoadBehindButton ? !!loadBehindButtonTitle : true}
            />
            <TextAreaField
              type={'text'}
              name={'description'}
              icon={<ComposeIcon />}
              label={'Description'}
              value={loadBehindButtonDescription}
              handleChange={e => onChange('loadBehindButtonDescription', e.target.value)}
              placeholder={'Enter description'}
              maxLength={200}
              required
              valid={useLoadBehindButton ? !!loadBehindButtonDescription : true}
            />
            <TextField 
              type={`text`} 
              name={`loadbehindbuttontext`} 
              icon={<ComposeIcon />}
              label={'Button text'}
              value={loadBehindButtonText} 
              handleChange={e => onChange('loadBehindButtonText', e.target.value)}
              placeholder={`Enter button text`} 
              maxLength={50}
              required
              valid={useLoadBehindButton ? !!loadBehindButtonText : true}
            />
          </Space>
          <PreviewConfig>
            <Space direction={'column'} gap={16} justifyContent={'center'} alignItems={'center'}>
              <img src={`${url.image}/2.0/loadbehindbutton.png`} />
              <h3>{loadBehindButtonTitle}</h3>
              <p style={{ textAlign: 'center'}}>{loadBehindButtonDescription}</p>
              <Button 
                text={loadBehindButtonText} 
                variant={'primary'}
              />
            </Space>
          </PreviewConfig>
        </Space>
      </ConfigToggle>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LoadBehindButton;